import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sponsor } from "../store/sponsor/actions";
import { useGetInsurance } from "./getInsurance";
export var useProjectsByCustomerId = function (clientId, trigger, descriptionInsurance, insuranceType, sponsorIdFilter) {
    var _a = useState(false), trigger2 = _a[0], setTrigger2 = _a[1];
    var _b = useState(""), sponsorId = _b[0], setSponsorId = _b[1];
    var _c = useState(true), enable = _c[0], setEnable = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(100), limit = _e[0], setLimit = _e[1];
    var dispatch = useDispatch();
    var _f = useGetInsurance(trigger2, sponsorIdFilter ? sponsorIdFilter : sponsorId, descriptionInsurance, insuranceType), responseInsurance = _f.responseInsurance, errorInsurance = _f.errorInsurance, loadingInsurance = _f.loadingInsurance;
    var _g = useSelector(function (state) {
        var _a;
        return ({
            responseSponsor: (_a = state.Sponsor.responseSponsor) === null || _a === void 0 ? void 0 : _a.data,
            errorSponsor: state.Sponsor.errorSponsor,
            loadingSponsor: state.Sponsor.loadingSponsor,
        });
    }), responseSponsor = _g.responseSponsor, errorSponsor = _g.errorSponsor, loadingSponsor = _g.loadingSponsor;
    useEffect(function () {
        if (trigger) {
            dispatch(sponsor({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
    }, [trigger]);
    useEffect(function () {
        if (responseSponsor && responseSponsor.length > 0) {
            var listSponsorFilter_1 = "";
            responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.map(function (sponsor, idx) {
                if (sponsor.id) {
                    listSponsorFilter_1 += "&sponsorId=".concat(sponsor.id);
                }
            });
            setSponsorId(listSponsorFilter_1);
            setTrigger2(true);
        }
    }, [responseSponsor]);
    return {
        responseSponsor: responseSponsor,
        errorSponsor: errorSponsor,
        loadingSponsor: loadingSponsor,
        responseInsurance: responseInsurance,
        errorInsurance: errorInsurance,
        loadingInsurance: loadingInsurance,
        setEnable: setEnable,
        setPage: setPage,
        setLimit: setLimit,
    };
};
